import React, { useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
const CanvasCam = (props, ref) => {
    const canvasRef = useRef(null);
    const videoRef = useRef(null);
    const startVideo = () => {
        const videoElement = videoRef.current;
        // Check if getUserMedia is available in the browser
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            navigator.mediaDevices
                .getUserMedia({ video: true })
                .then((stream) => {
                videoElement.srcObject = stream;
                videoElement.onloadedmetadata = () => {
                    const canvas = canvasRef.current;
                    const context = canvas.getContext("2d");
                    canvas.width = videoElement.videoWidth;
                    canvas.height = videoElement.videoHeight;
                    videoElement.play();
                    // Draw video frames onto the canvas
                    videoElement.addEventListener("play", () => {
                        const draw = () => {
                            context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
                            requestAnimationFrame(draw); // Keep drawing the video
                        };
                        draw();
                    });
                };
            })
                .catch((err) => {
                console.error("Error accessing the camera: ", err);
            });
        }
        else {
            console.log("getUserMedia is not supported in this browser");
        }
    };
    useEffect(() => {
        startVideo();
    }, []);
    useImperativeHandle(ref, () => ({
        getImageData: () => {
            const canvas = canvasRef.current;
            const dataUrl = canvas.toDataURL("image/png");
            return dataUrl;
        }
    }));
    return (React.createElement("div", { className: "CanvasCam" },
        React.createElement("canvas", { ref: canvasRef, className: "photo", style: { border: "1px solid black" } }),
        React.createElement("video", { ref: videoRef, style: { display: "none" } })));
};
export default forwardRef(CanvasCam);
